import { Wrapper } from '@styles/CommonStyles';
import { useLenderId } from '@shared/hooks/useLenderId';
import { LenderControlsHeader } from '../shared/LenderControlsHeader';
import { LenderEditorTabs } from './tabs/LenderEditorTabs';

export const LenderEditorTitle = 'Lender Editor';

export const LenderEditor = () => {
  const lenderId = useLenderId();

  return (
    <Wrapper>
      <LenderControlsHeader title={LenderEditorTitle}/>

      <LenderEditorTabs key={lenderId} lenderId={lenderId} />
    </Wrapper>
  );
};
